import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@popperjs/core";
import "bootstrap";
import Maska from "maska";
import { hasFieldError, getFieldErrorMsg, hasRecordError } from "./apiErrorHandling"

export function groupBy<T>(array: any[], key: string) {
  const result: { [key: string]: any[] } = {};
  array.forEach((item) => {
    if (!result[item[key]]) {
      result[item[key]] = [];
    }
    result[item[key]].push(item);
  });
  return result;
}

export function formatPhoneNumber(phoneNumberString: string): string {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return phoneNumberString;
}

export function generateGuid() {
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
   });
}

createApp(App).mixin({
   methods: {
      hasFieldError: hasFieldError,
      getFieldErrorMsg: getFieldErrorMsg,
      hasRecordError: hasRecordError
   }
}).use(router).use(Maska).mount("#app");
